import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const Markdown = ({ body, testId = "article-longform-body" }) => (
  <div className="prose-uk" data-testid={testId}>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{body || ""}</ReactMarkdown>
  </div>
);
